export default __webpack_public_path__ + "static/media/heroImg2.94fd1aa5.png";